@if ({ isMobile: isMobile$ | async }; as ctx) { @if (header) { @if
(showLookBookName && lookBook?.title) {
<h2 class="font-weight-bold">
  {{ lookBook?.title }}
</h2>
}
<h2 class="user-content-title" [ngClass]="isCommercial ? 'mb-2' : 'mb-0'">
  <span
    data-e2e="list-title"
    class="list-title"
    [class.commercial-list-title]="isCommercial"
  >
    <epc-hot-list-indicator
      [listId]="list?.id"
      [showAlmostHotIconBasedOnUserRole]="true"
      class="align-middle hot-list-icon"
    ></epc-hot-list-indicator>
    <span>{{ header }}</span>
    <button
      class="share-button align-middle btn"
      data-e2e="copy-link-item"
      [class.ml-auto]="ctx.isMobile"
      [epcShareableProductList]="shareableList"
      [epcShareableProductListLookbookId]="lookBook?.id"
    >
      <fa-icon
        [icon]="!ctx.isMobile ? ['fas', 'link'] : ['fas', 'share-nodes']"
        class="d-flex share-button-icon"
        [tooltipEnabled]="!ctx.isMobile"
        [atxTooltip]="copyLinkTooltip"
        tooltipPlacement="top"
      ></fa-icon>
    </button>
  </span>
</h2>
} }
